import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Drawer, InfoMessage } from '@root/shared/ui-kit'

import { reportUserFlowAtom } from '../atoms/reatom-report-user-flow'

import { ReportUserForm } from './common/report-user-form'

type ReportUserDrawerProps = {}

export const ReportUserDrawer = (_props: ReportUserDrawerProps) => {
  const { t } = useTranslation()
  const [reportUser, setReportUser] = useAtom(reportUserFlowAtom)

  const handleClose = () => setReportUser(undefined)

  return (
    <Drawer
      open={!!reportUser}
      onOpenChange={handleClose}
      title={t('common.report')}
    >
      {reportUser?.user ? (
        <Wrapper>
          <ReportUserForm user={reportUser.user} onDone={handleClose} />
        </Wrapper>
      ) : (
        <InfoMessage intent="empty" variant="dt" />
      )}
    </Drawer>
  )
}

const Wrapper = styled.div`
  padding: 12px;
  border-radius: 12px;
`
